import { render, staticRenderFns } from "./ProjectListOverallTemplate.vue?vue&type=template&id=47d6b5c3&scoped=true&"
import script from "./ProjectListOverallTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectListOverallTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListOverallTemplate.vue?vue&type=style&index=0&id=47d6b5c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6b5c3",
  null
  
)

export default component.exports